import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { XNav } from '@ximdex/xui-react/material';
import { CLIENT, XEDIT_URI_API, XPANEL_URI_API, COOKIE_NAME} from '../../CONSTANTS';
import { LogOut, User } from 'lucide-react';
import useAuth from '../../hooks/useAuth';

const Navbar = () => {
    const navigate = useNavigate();
    const { handleLogOut } = useAuth();

    const externalLinks = [
        {
            icon: <FontAwesomeIcon icon={faExternalLinkAlt} size="1x" title="Go to xPanel" />,
            text: 'xPanel',
            url: XPANEL_URI_API,
            target: '_self'
        },
        {
            icon: <FontAwesomeIcon icon={faExternalLinkAlt} size="1x" title="Go to xEdit" />,
            text: 'xEdit',
            url: XEDIT_URI_API,
            target: '_self'
        }
    ];

    const internalLinks = [
        {
            text: 'Activities',
            url: '/list-activities',
            target: '_self'
        },
        {
            text: 'Assessments',
            url: '/list-assessments',
            target: '_self'
        }
    ];

    const userLink = [
        {
            text: sessionStorage.hasOwnProperty(COOKIE_NAME) ? JSON.parse(sessionStorage.getItem(`${COOKIE_NAME}`))?.user?.name : JSON.parse(sessionStorage.getItem(`${COOKIE_NAME}_XEVAL`))?.user?.name ?? 'xeval user',
            icon: <User size={20}/>,
            items: [
                {
                    text: 'Sign out',
                    icon: <LogOut size={20} style={{ marginRight: '8px'}} />,
                    onClick: () => {
                        handleLogOut(COOKIE_NAME);
                        navigate('/login', 'logout')
                    }
                }
            ]
        },
    ];

    const links = CLIENT === 'SEK' ? [ internalLinks, externalLinks, userLink] : [internalLinks, userLink];

    const logoLink = {
        logoImgSrc: '/assets/images/logotipo_ximdex-eval-white-small.png'
    }

    return (
        <XNav
            color='secondary'
            style={{backgroundColor:'#214F61', position:'fixed', top:'0',zIndex: '10'}}
            logoLink={logoLink}
            links={links}
        />
    );
};

export default Navbar;
